import { render } from "./TheSnackbarStack.vue?vue&type=template&id=5ae83f9f"
import script from "./TheSnackbarStack.vue?vue&type=script&lang=js"
export * from "./TheSnackbarStack.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__